"use client";

import { RelationView } from "./characterViews";

/**
 * 関係のタブ。人物の relations/ の相手を 1 件ずつ並べる。名の横に 関係 を添え、押すと開いて 人物像・経緯 を出す。
 * 中身はその人物の側から書いた md で、キャラの中身（GET /api/character/detail・GET /api/admin/npc/detail）の relations
 */
export default function PlayRelations({ relations }: { relations: RelationView[] }) {
  if (relations.length === 0) return <div className="pl-empty">関係はありません。</div>;
  return (
    <div className="pl-prof">
      <section className="pl-prof-sec">
        {relations.map((one) => (
          <details className="review-card" key={one.ref}>
            <summary>
              <span className="review-card-name">{one.name}</span>
              <span className="review-card-meta">{one.relation}</span>
            </summary>
            {one.image ? (
              <div className="review-block">
                <h4 className="review-h4">人物像</h4>
                <p className="review-p">{one.image}</p>
              </div>
            ) : null}
            {one.history.length > 0 ? (
              <div className="review-block">
                <h4 className="review-h4">経緯</h4>
                {one.history.map((line, index) => (
                  <p className="review-p" key={index}>
                    {line}
                  </p>
                ))}
              </div>
            ) : null}
          </details>
        ))}
      </section>
    </div>
  );
}
